import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicTextArea, BasicInput, BasicFieldCheckbox, DatePickerField } from "core/components";
import { ApplicationEditLayout, Content } from "core/layouts";
import { map } from "lodash";

const TrackingCaseDocumentFieldValueEditTemplate = function({ trackingCaseDocumentFieldValueEditViewStore }) {
	const {
		contentLoading,
		form,
		items,
		backgroundImage
	} = trackingCaseDocumentFieldValueEditViewStore;

	function renderInputType(item) {
		let documentFormField= item.documentFormField;

		const wrapperStyle = {
			position: 'absolute',
			top: `${documentFormField.top}px`,
			left: `${documentFormField.left}px`,
			width: `${documentFormField.width}px`,
			fontSize: `${documentFormField.fontSize}px`
		};

		const inputStyle = { 
			height: `${documentFormField.height}px`,
			'font-weight':`${documentFormField.fontBold? 'bold' : 'normal'}`
		};

		switch(item.documentFormField.documentFormFieldType.abrv) {
			case 'date':
				return <div style={wrapperStyle}><DatePickerField field={form.$(documentFormField.abrv)} /></div>;
			case 'check':
				return <div style={wrapperStyle}><BasicFieldCheckbox field={form.$(documentFormField.abrv)} /></div>;
			default:
				return <div style={wrapperStyle}>
					{  item.documentFormField.multiLine ?
						<BasicTextArea multiLineEdit={true} field={form.$(documentFormField.abrv)} style={inputStyle} /> : 
						<BasicInput field={form.$(documentFormField.abrv)} showLabel={false} style={inputStyle} />
					}
				</div>;
		}
    }

	const templateStyles = { 
		position: 'relative',
		height: '1754px',
		width: '1240px',
		backgroundImage:`url(/${backgroundImage})`, 
		backgroundSize: '100% 100%'
	};

	return (
		<ApplicationEditLayout store={trackingCaseDocumentFieldValueEditViewStore}>
			<Content loading={contentLoading}>
				<div className="card card--form card--primary card--med" style={templateStyles}> 
					{items && map(items, item =>
						renderInputType(item)
					)}
				</div>
			</Content>
		</ApplicationEditLayout>
	);
};

TrackingCaseDocumentFieldValueEditTemplate.propTypes = {
	trackingCaseDocumentFieldValueEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func
};

export default defaultTemplate(TrackingCaseDocumentFieldValueEditTemplate);